"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPathNamesLink = void 0;
var buildInternalRoute_1 = require("./buildInternalRoute");
var nextPath = function (path, prevLinks) {
    var links = prevLinks || [];
    links.push({
        _key: "key-internalLink-".concat((0, buildInternalRoute_1.buildInternalRoute)(path), "-").concat(path.title),
        _type: 'internalLink',
        label: path.title,
        to: __assign({}, path),
    });
    // eslint-disable-next-line no-underscore-dangle
    if (path._type === 'rootPage') {
        return links;
    }
    return nextPath(path.parentPage, links);
};
var buildPathNamesLink = function (pathNames) { return nextPath(pathNames).reverse(); };
exports.buildPathNamesLink = buildPathNamesLink;
